var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4254 22.4091L18.4236 22.4098C18.3019 22.4552 18.1754 22.4516 18.0664 22.4194L18.0628 22.4183L11.384 20.3538L6.81848 22.0223C5.93369 22.347 5 21.6843 5 20.7432V10.2415C5 9.66896 5.35506 9.15807 5.8933 8.96216L11.1764 7.03395C11.2981 6.98857 11.4246 6.99212 11.5336 7.02433L11.5372 7.0254L18.216 9.08993L22.7819 7.4213C23.6699 7.0969 24.6 7.75956 24.6 8.70055V19.2022C24.6 19.7748 24.2449 20.2858 23.7066 20.4816L18.4254 22.4091ZM6.27729 10.0261C6.1882 10.0589 6.12778 10.1449 6.12778 10.2415V20.7432C6.12778 20.9034 6.28431 21.0129 6.43447 20.9583L10.8056 19.3635V14.233V8.37076L6.73049 9.86046L6.27729 10.0261ZM17.6667 10.1015L11.9333 8.32858V15.4431V19.3422L17.0384 20.9209L17.6667 21.1152V10.1015ZM23.3226 19.4177L18.7944 21.073V10.0802L23.1655 8.48541C23.3156 8.43099 23.4722 8.54039 23.4722 8.70055V19.2022C23.4722 19.2989 23.4117 19.3849 23.3226 19.4177Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIcon);
export default __webpack_public_path__ + "static/media/map-icon.a6f6ea964e28cf43e09a3920a9726260.svg";
export { ForwardRef as ReactComponent };